export default (function (e) {
  return "string" == typeof e && new RegExp("^[a-z][a-z0-9+.-]*:").test(e);
});